// document.addEventListener("DOMContentLoaded", function () {
//     const header = document.querySelector(".header");
//     const triggerHeight = window.innerHeight * 0.7;

//     window.addEventListener("scroll", function () {
//         if (window.scrollY > triggerHeight) {
//             header.classList.add("scrolled");
//         } else {
//             header.classList.remove("scrolled");
//         }
//     });
// });


document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector(".mobile_search_popup_ul");
  const button = document.querySelector(".mobile_search_popup button");

  // Toggle popup when button is clicked
  button.addEventListener("click", function (e) {
    e.stopPropagation(); // prevent closing immediately
    popup.classList.toggle("active");
  });

  // Close popup if clicking outside
  document.addEventListener("click", function (e) {
    if (!popup.contains(e.target) && !button.contains(e.target)) {
      popup.classList.remove("active");
    }
  });
});
